export const MESSAGE = {
  INVALID_FORMAT: "Invalid Serial Number Format",
  FETCHING_ERROR: "Failed to fetch data. Please try again.",
  TOWER_EXISTED: "Tower already Exist",
  TOWER_CREATED: "Created Tower Successfully",
  TOWER_UPDATED: "Updated Tower Successfully",
  SUCCESS_GENERATED: "Serial Number generated successfully",
  SERVER_ERROR: "Something went wrong",
};

export const PAGINATION = {
  DEFAULT_PAGE_NUMBER: 1,
  DEFAULT_PAGE_LIMIT: 10,
  PAGE_LIST: [1, 2, 5, 10, 25, 50],
};
